import { UserAddress } from "../../ts/interfaces"
import { OrderData } from "./orders/orderTypes"
import { Membership, MembershipProps } from "./subscriptions/membership"

export interface Headset {
  id: string
  trialActivated: boolean
  trialNumberDays: number
  trialStartDate: {
    formatted: string
  }
}

export interface UserType {
  id: string
  firstName: string
  lastName: string
  email: string
  shippingAddresses?: UserAddress[]

  membership?: MembershipProps
  proMembership?: MembershipProps
  expiredProMemberships: MembershipProps[]
  expiredMemberships: MembershipProps[]
  headset: Headset[]
  orders: OrderData[]

  proConfig?: {
    organizationName?: string
  }
  affiliate?: {
    id: string
  }
}

export class User {
  id: string
  firstName: string
  lastName: string
  email: string
  shippingAddresses?: UserAddress[]
  membership?: Membership
  proMembership?: Membership
  expiredMemberships: Membership[]
  expiredProMemberships: Membership[]
  headset: Headset[]
  orders: OrderData[]
  organizationName?: string
  affiliate?: {
    id: string
  }

  constructor(props: UserType) {
    this.id = props.id
    this.firstName = props.firstName
    this.lastName = props.lastName
    this.email = props.email
    this.shippingAddresses = props.shippingAddresses
    this.membership = props.membership
      ? new Membership(props.membership)
      : undefined
    this.proMembership = props.proMembership
      ? new Membership(props.proMembership)
      : undefined
    this.expiredMemberships = props.expiredMemberships.map(
      p => new Membership(p)
    )
    this.headset = props.headset
    this.expiredProMemberships = props.expiredProMemberships.map(
      p => new Membership(p)
    )
    this.organizationName = props.proConfig?.organizationName
    this.orders = props.orders.sort(
      (a, b) =>
        new Date(b.created.formatted).getTime() -
        new Date(a.created.formatted).getTime()
    )
    this.affiliate = props.affiliate
  }

  hasPersonalMembership(): boolean {
    return !!this.membership && this.membership.status !== "inactive"
  }

  hasProfessionalMembership(): boolean {
    return !!this.proMembership && this.proMembership.status !== "inactive"
  }

  hasProConfig(): boolean {
    return !!this.organizationName
  }

  showProfessionalMembership(): boolean {
    return (
      this.hasProfessionalMembership() ||
      this.expiredProMemberships.length > 0 ||
      this.hasProConfig()
    )
  }
}
